var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.$vuetify.breakpoint.mdAndDown ? [_c('v-col', {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "mobile_filters buttons"
  }, [_c('TxParamsDialog', {
    attrs: {
      "chain-color": _vm.currentBlockChainColor
    },
    on: {
      "change": _vm.emitChange
    }
  }), _c('TxFilterDialog', {
    attrs: {
      "chains": _vm.chains,
      "chain-color": _vm.currentBlockChainColor
    },
    on: {
      "change": _vm.setFilter
    }
  })], 1)]), !_vm.loading && _vm.assetsLoaded ? _c('TxList', {
    attrs: {
      "transactions": _vm.filteredTransactions
    }
  }) : _c('Loader', {
    attrs: {
      "message": "Loading transactions",
      "content-id": ""
    }
  }), _c('div', {
    staticClass: "footer"
  }, [!_vm.loading && _vm.hasMore ? _c('button', {
    staticClass: "dcm_btn btn-more",
    on: {
      "click": _vm.emitMore
    }
  }, [_vm._v(" Load More ")]) : _vm._e()])] : [_c('div', {
    staticClass: "two-col"
  }, [_c('div', {
    staticClass: "card filter"
  }, [_c('TxParams', {
    attrs: {
      "title": "SORT RESULTS",
      "chain-color": _vm.currentBlockChainColor
    },
    on: {
      "change": _vm.emitChange
    }
  }), _c('TxFilter', {
    attrs: {
      "chains": _vm.chains,
      "chain-color": _vm.currentBlockChainColor
    },
    on: {
      "change": _vm.setFilter
    }
  })], 1), _c('div', {
    staticClass: "card trasactions"
  }, [!_vm.loading && _vm.assetsLoaded ? _c('TxList', {
    attrs: {
      "transactions": _vm.filteredTransactions
    }
  }) : _c('Loader', {
    attrs: {
      "message": "Loading transactions",
      "content-id": ""
    }
  }), _vm.filters.length > 0 ? _c('div', {
    staticClass: "footer"
  }, [!_vm.loading && _vm.hasMore ? _c('button', {
    staticClass: "dcm_btn btn-more",
    on: {
      "click": _vm.emitMore
    }
  }, [_vm._v(" Load More ")]) : _vm._e()]) : _vm._e()], 1)])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }